<div class="exibicao-paginacao">
  <span>Exibir</span>
  <app-select
    ngClass="form-control-selecao select-registros-vale"
    (valueChanges)="pageSizeChange.emit($event)"
    [value]="pageSize"
    [id]="itensPorPaginaId"
    [options]="opcoesTamanho"
    optionValue="value"
    optionText="name">
  </app-select>
  <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
  <span> por página</span>
</div>
<div class="paginacao-centro-padding">
  <pagination-controls
    [id]="paginacaoId"
    (pageChange)="pageChange.emit($event)"
    directionLinks="false"
    autoHide="false"
    responsive="true"
    previousLabel=""
    nextLabel=""
    screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="page"
    screenReaderCurrentLabel="Página">
  </pagination-controls>
</div>
<div class="paginacao-direita-padding">
  <span class="subtitulo-table">
    <b style="font-weight: 600">{{ totalItems }}</b> Registros foram encontrados
  </span>
</div>
